import React from 'react';
import { useIntl } from 'react-intl';

import { IconCross } from '@xingternal/icons';

import { DEFAULT_SORT } from '@/domain/search/constants';
import { useSearchQuery } from '@/domain/search/contexts';
import { isFullRemoteOnlyByQueryParam } from '@/domain/search/helpers';
import { useSearch } from '@/domain/search/hooks';
import { buildSearchCriteria } from '@/helpers/build-search-criteria';

import * as S from './small-screen-filters-summary.styles';

export const SmallScreenFiltersSummary: React.FC = () => {
  const intl = useIntl();
  const { data } = useSearch();
  const {
    queryParams: [{ sort, radius, remoteOption }, setQueryParams],
  } = useSearchQuery();

  const maybeBody = data?.jobSearchByQuery?.searchQuery.body;
  const searchCriteria = maybeBody
    ? buildSearchCriteria({ filterCollection: maybeBody.filterCollection }, intl)
    : undefined;

  const isFullRemote = isFullRemoteOnlyByQueryParam(remoteOption);
  const text = [
    ...(searchCriteria ? [searchCriteria] : []),
    ...(sort && sort != DEFAULT_SORT ? [intl.formatMessage({ id: `SE_SORT_JOBS_${sort.toUpperCase()}_LABEL` })] : []),
    ...(radius && !isFullRemote
      ? [intl.formatMessage({ id: 'JOBS_SEARCH_RADIUS_FILTERS_SUMMARY' }, { value: radius })]
      : []),
  ].join(' + ');

  if (!text) {
    return null;
  }

  const handleOnResetFilters = (): void => {
    // Empty filters
    setQueryParams({
      benefit: undefined,
      careerLevel: undefined,
      city: undefined,
      company: undefined,
      country: undefined,
      discipline: undefined,
      employmentType: undefined,
      industry: undefined,
      salary: undefined,
      sort: undefined,
      radius: undefined,
      remoteOption: undefined,
    });
  };

  return (
    <S.Container>
      <S.Text size="small">{text}</S.Text>
      <S.ResetButton icon={IconCross} size="small" onClick={handleOnResetFilters}>
        {intl.formatMessage({ id: 'JOBS_SEARCH_RESET_FILTERS_BUTTON' })}
      </S.ResetButton>
    </S.Container>
  );
};
